module.exports = __webpack_public_path__ + "img/qr-faq.283a0c09.png";